import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useTheme } from '@mui/material';
import { memo, useMemo } from 'react';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { GSMAdditionalInfoIcon } from 'console/shared/components/indicators/gsm/additional';
import { IconElement } from 'console/shared/components/indicators/gsm/icon';
import { getConnectionIconsDevice, getOnlineColor, getRadioSilence, } from 'console/shared/components/indicators/gsm/utils/selectors';
import { simProblemStatusState } from 'console/sim/utils/sim-problem';
export const GSMIcon = memo(function GSMIcon(props) {
    const { open, device_id, ...rest } = props;
    const theme = useTheme();
    const gsm_icon = usePartialAppSelector(getConnectionIconsDevice, device_id)?.gsm;
    const color = usePartialAppSelector(getOnlineColor, device_id);
    const sim_status = usePartialAppSelector(simProblemStatusState, device_id, true);
    const warning = useMemo(() => sim_status == 'warning', [sim_status]);
    const error = useMemo(() => sim_status == 'error', [sim_status]);
    const radio_silence = usePartialAppSelector(getRadioSilence, device_id);
    const _error = useMemo(() => error || radio_silence, [error, radio_silence]);
    if (!gsm_icon) {
        return null;
    }
    return (_jsxs(Box, { display: "flex", position: "relative", alignItems: "center", onClick: open, columnGap: 0.5, children: [_jsx(GSMAdditionalInfoIcon, { warning: warning, error: error }), _jsx(IconElement, { icon_type: gsm_icon, stroke: _error
                    ? theme.palette.error.main
                    : warning
                        ? theme.palette.warning.main
                        : undefined, color: color, ...rest })] }));
});
